(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    (function () {
      document.querySelectorAll('[data-form-body]').forEach(function (body) {
        var form = body.closest('form');
        if (!form || form.dataset.buttonFormBound) return;
        form.dataset.buttonFormBound = 'true';

        form.addEventListener('submit', function () {
          var lines = [];
          form.querySelectorAll('[data-option-group]').forEach(function (group) {
            var checked = group.querySelector('input[type="radio"]:checked');
            if (checked) lines.push(group.getAttribute('data-option-group') + ': ' + checked.value);
          });
          if (lines.length) {
            var note = body.value.trim();
            body.value = lines.join('\n') + (note ? '\n\nNote:\n' + note : '');
          }
        });
      });

      document.querySelectorAll('[data-button-form-result]').forEach(function (result) {
        var dialogComponent = result.closest('dialog-component');
        if (dialogComponent && typeof dialogComponent.showDialog === 'function') {
          dialogComponent.showDialog();
        }
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
